export enum ROLES {
  ADMIN = 'ADMIN',
  SITE_ADMIN = 'SITE_ADMIN',
  USER = 'USER',
  READ_ONLY = 'READ_ONLY',
}

export const ADMIN_ROLES = [ROLES.ADMIN, ROLES.SITE_ADMIN];

export const USER_ROLE_ID = 3;